module.exports = __webpack_public_path__ + "img/solution_overview.1175b7d5.png";